import { useMutation } from '@tanstack/react-query';
import {
  ChangePasswordParams,
  UseChangePasswordOptions,
} from '../../../interface/settings';
import { changePassword } from '../../settings';

export const useChangePassword = ({
  onSuccess,
  onError,
}: UseChangePasswordOptions = {}) => {
  const {
    mutate: changePwd,
    data: changePasswordData,
    isPending: isChangePasswordPending,
    isSuccess: isChangePasswordSuccess,
  } = useMutation({
    mutationFn: (payload: ChangePasswordParams) => changePassword(payload),
    onSuccess,
    onError,
  });

  return {
    changePwd,
    changePasswordData,
    isChangePasswordPending,
    isChangePasswordSuccess,
  };
};
